import Translation from '../../services/translation/Translation';

export default function addTranslation(language: string, namespace: string, resource: Record<string, string>) {
  Translation.addTranslation(language, namespace, resource);
}
